import styled from "styled-components";
import SectionTitle from "./SectionTitle";
import { useMemo } from "react";
import Card from "./Card";
import FadeInItem from "./FadeInItem";
import { handleLink } from "../utils/handleLink";

const Goods = () => {
  const goodsList = useMemo(
    () => [
      {
        link: "https://www.emotioncastle.com/products/120811781",
        id: "goods_1.webp",
        title: "매지컬 컴팩트 가방세트",
      },
      {
        link: "https://www.emotioncastle.com/products/120811778",
        id: "goods_2.jpg",
        title: "매지컬 로드 장갑세트",
      },
      {
        link: "https://www.emotioncastle.com/products/120811777",
        id: "goods_3.jpg",
        title: "하츄핑 하우스",
      },
    ],
    []
  );

  return (
    <Wrapper id="goods">
      <SectionTitle>GOODS</SectionTitle>
      <FadeInItem point={0.25}>
        <GoodsWrapper>
          <div>
            {goodsList.map((goods) => (
              <Card
                key={goods.id}
                id={goods.id}
                title={goods.title}
                handleClick={() => handleLink(goods.link)}
              />
            ))}
          </div>
        </GoodsWrapper>
      </FadeInItem>
    </Wrapper>
  );
};

export default Goods;

const Wrapper = styled.div`
  padding: 140px 0 210px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (max-width: 1150px) {
    padding: 80px 0 128px;
  }
`;

const GoodsWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  > div {
    @media only screen and (min-width: 1150px) {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      margin-top: 100px;
      gap: 30px;
    }

    @media only screen and (max-width: 1150px) {
      width: 100%;
      display: flex;
      gap: 16px;
      padding: 0 16px;
      overflow-x: scroll;
      margin-top: 24px;
    }
  }
`;
